/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type FormSubmitEntrypointComponent = EntryPointComponent<{}, {}, {}, {}>;

export const formSubmitEntrypoint: EntryPoint<FormSubmitEntrypointComponent, {}> = createEntryPoint(
	{
		root: JSResourceForUserVisible<FormSubmitEntrypointComponent>(
			/* webpackChunkName: "async-business-form-submit-entrypoint" */ './JiraBusinessFormAppMemo.tsx',
			{
				entryFsSsrLiftImportToModule: true,
			},
		),
		getPreloadProps: () => ({}),
	},
);
